import { invalidateCanvas } from '$viewer/overlay/invalidateCanvas';
import { useDevOverlayStore } from '$viewer/store/devOverlayStore';

/** 브라우저 콘솔에서 호출하는 개발자용 명령의 공통 접두어입니다. 모든 명령은 이 접두어를 씁니다. */
export const DEV_COMMAND_PREFIX = '__dev__';

/** `window.__dev__<name>` 으로 명령을 노출합니다. 이름에 접두어를 직접 붙이지 않습니다. */
export const registerDevCommand = (
  name: string,
  command: (...argList: never[]) => unknown,
): void => {
  window[`${DEV_COMMAND_PREFIX}${name}`] = command;
};

/**
 * `__dev__vObjectOverlay()` 로 반전, `__dev__vObjectOverlay(true | false)` 로 지정합니다.
 * 캔버스가 demand 모드라 토글만으로는 다시 그려지지 않아 직접 무효화합니다.
 */
const toggleVObjectOverlay = (enabled?: boolean): boolean => {
  const next = useDevOverlayStore.getState().toggleVObjectOverlay(enabled);
  invalidateCanvas();

  return next;
};

/** 앱 시작 시 한 번 호출해 모든 앱 공통 개발자용 콘솔 명령을 등록합니다. 앱 전용 명령은 앱이 따로 등록합니다(apps/main/src/app/registerMainDevCommandList.ts 등). */
export const registerDevCommandList = (): void => {
  registerDevCommand('vObjectOverlay', toggleVObjectOverlay);
};
